import { apiFetch } from "../client"

export function getAssignmentSummary(params?: Record<string, string>) {
  const query = params ? `?${new URLSearchParams(params).toString()}` : ""
  return apiFetch<any>(`/assignments/summary${query}`)
}

export function commitAssignments(payload: {
  items: Array<{
    clientId: string
    destinationAgentId: string
    sourceAgentId?: string
    reassignmentReason?: string
  }>
  note?: string
}) {
  return apiFetch<any>("/assignments", {
    method: "POST",
    rawBody: payload,
  })
}
